import { render, staticRenderFns } from "./KeepableSlot.vue?vue&type=template&id=21eef8cf"
import script from "./KeepableSlot.vue?vue&type=script&lang=js"
export * from "./KeepableSlot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports